module.exports = __webpack_public_path__ + "img/comp-36.a4579841.png";